import { render, staticRenderFns } from "./AvgScore.vue?vue&type=template&id=7463699a&scoped=true&"
import script from "./AvgScore.vue?vue&type=script&lang=ts&"
export * from "./AvgScore.vue?vue&type=script&lang=ts&"
import style0 from "./AvgScore.vue?vue&type=style&index=0&id=7463699a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463699a",
  null
  
)

export default component.exports